import React from 'react'
import useTranslation from '../../shared/TranslationProvider'
import { useExercise } from '../ExerciseProvider'

const PartThree = () => {
  const {
    exerciseIndex,
    updateDecisionMakingExerciseResponse,
    getDecisionMakingExerciseResponse,
    setContinueButtonDisabled,
  } = useExercise()
  const { t } = useTranslation(
    `decision_making.pages.${exerciseIndex}.career-options`,
  )
  const updatePositions = (position, index) => {
    console.log('updatePositions', position, index)
    const positions =
      getDecisionMakingExerciseResponse('positions') || new Array(3)
    positions[index] = position
    updateDecisionMakingExerciseResponse(
      'positions',
      positions?.filter((el) => el && el.trim() !== ''),
    )
    setContinueButtonDisabled(
      getDecisionMakingExerciseResponse('positions').length < 2,
    )
  }
  return (
    <>
      <h1>{t('title')}</h1>
      <p className="pb-4">{t('p1')}</p>
      <div className="questions flex flex-col items-center gap-4">
        <div>
          <label htmlFor="option-1" className="pr-4">
            {t('option1')}
          </label>
          <input
            type="text"
            id="option-1"
            className="mr-3 w-1/2 rounded font-roboto text-base font-medium"
            value={
              getDecisionMakingExerciseResponse('positions')
                ? getDecisionMakingExerciseResponse('positions')[0]
                : ''
            }
            placeholder={t('placeholder')}
            onChange={(e) => updatePositions(e.target.value, 0)}
          />
        </div>
        <div>
          <label htmlFor="option-2" className="pr-4">
            {t('option2')}
          </label>
          <input
            type="text"
            id="option-2"
            className="mr-3 w-1/2 rounded font-roboto text-base font-medium"
            value={
              getDecisionMakingExerciseResponse('positions')
                ? getDecisionMakingExerciseResponse('positions')[1]
                : ''
            }
            placeholder={t('placeholder')}
            onChange={(e) => updatePositions(e.target.value, 1)}
          />
        </div>
        <div>
          <label htmlFor="option-3" className="pr-4">
            {t('option3')}
          </label>
          <input
            type="text"
            id="option-3"
            className="mr-3 w-1/2 rounded font-roboto text-base font-medium"
            value={
              getDecisionMakingExerciseResponse('positions')
                ? getDecisionMakingExerciseResponse('positions')[2]
                : ''
            }
            placeholder={t('placeholder')}
            onChange={(e) => updatePositions(e.target.value, 2)}
          />
        </div>
      </div>
    </>
  )
}

export default PartThree
